import configurationServices from '@/configuration/services/services'

import { settingsFormFields } from '../IntegrationDetailBody/DefaultIntegration/IntegrationSettings/constants'
import * as navigation from './navigation'

export const getIntegrationPayload = integration => {
  const configuration = Object.entries(integration.configuration).reduce((acc, [key, config]) => {
    if (settingsFormFields[key]?.optional && !config.value) return acc

    acc[key] = config.value
    return acc
  }, {})

  return {
    ...integration,
    configuration,
  }
}

export const customIntegrations = {
  gorgias: async ({ storeId, integrationId }) => {
    const response = await configurationServices.gorgiasIntegration({ storeId, integrationId })

    navigation.navigateTo(response.data.url)
  },
  stripe: async ({ storeId, integrationId }) => {
    const linkResponse = await configurationServices.installStripeAccount({ storeId, integrationId })

    if (linkResponse?.data?.url) {
      navigation.navigateTo(linkResponse.data.url)
    }
  },
}
